







import { Vue, Component, Prop } from 'vue-property-decorator';
import { EAlignFieldType } from '@/dealroom/fields/context-menu/types/enums/align-field-type';
import Icon from '@/components/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class FieldAlignItem extends Vue {
  @Prop() icon: string;
  @Prop() text: string;
  @Prop() actionType: EAlignFieldType;

  select(actionType: EAlignFieldType) {
    this.$emit('select', actionType);
  }
}
